import React from "react";
import { z } from "zod";
import styled from "styled-components";
import { FeatureCarousel, CarouselSlide, CarouselSlides, CarouselViewport, CarouselProgressBar, CarouselControls, CarouselPrevious, CarouselNext, } from "../../../components/Carousel";
import { ArticleFeaturedCard } from "../../../molecules/ArticleFeaturedCard";
import { Blade } from "../../../components/Blade";
import { LegacyBladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderHeading, BladeHeaderTitle, } from "../../../components/BladeHeader";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ContentListBladeSchema } from "../../../schemas/blades/ContentList";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { RichText } from "../../../components/RichText";
export const FeaturedNewsCarouselContractSchema = ContentListBladeSchema.extend({
    type: z.literal("featuredNewsCarousel"),
});
const FeaturedNewsSlide = ({ content, slideIndex, slideTotal, ...props }) => {
    const { action } = content;
    const classNames = action ? "clickable" : "";
    return (React.createElement(CarouselSlide, { className: classNames, ...props },
        React.createElement(AnalyticsProvider, { uiLocation: `slide[${slideIndex + 1}:${slideTotal}]` },
            React.createElement(ArticleFeaturedCard, { content: content }))));
};
const _FeaturedNewsCarousel = ({ backdrop, header, items, ...props }) => {
    const headerContent = hasVisibleContent(header);
    const { background, foreground } = backdrop || {};
    return (React.createElement(Blade, { "data-testid": "featured-news-carousel", ...props },
        React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, background && React.createElement(Media, { media: background, role: "presentation" })),
            React.createElement(BackdropForeground, null, foreground && React.createElement(Media, { media: foreground, role: "presentation" }))),
        header && headerContent && (React.createElement(LegacyBladeHeader, null,
            React.createElement(BladeHeaderHeading, null,
                header.supertitle && React.createElement(BladeHeaderSupertitle, null, header.supertitle),
                header.title && (React.createElement(BladeHeaderTitle, null,
                    React.createElement("h2", null, header.title)))),
            header?.description ? (React.createElement(BladeHeaderBody, null,
                React.createElement(RichText, { ...header.description }))) : null)),
        React.createElement(AnalyticsProvider, { uiLocation: "carousel" },
            React.createElement(FeatureCarousel, { draggable: true },
                React.createElement(CarouselViewport, null,
                    React.createElement(CarouselSlides, null, items.map((item, index) => {
                        return React.createElement(FeaturedNewsSlide, { content: item, slideIndex: index, slideTotal: items.length, key: index });
                    }))),
                React.createElement(CarouselControls, null,
                    React.createElement(CarouselProgressBar, null),
                    React.createElement("div", { className: "trigger-wrapper" },
                        React.createElement(CarouselPrevious, null),
                        React.createElement(CarouselNext, null)))))));
};
export const FeaturedNewsCarousel = styled(_FeaturedNewsCarousel) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=FeaturedNewsCarousel.js.map